import I18n from 'I18n';
import { useState } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { ActionsMenu } from 'foundations-components/components/ActionsMenu';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { RenameInput } from './RenameInput';
import { bucketFor } from '../../utils/conversationGrouping';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ConversationRow = ({
  row,
  isActive,
  isMobile,
  onOpen,
  onRename,
  onDelete,
  trackEvent
}) => {
  var _row$title;
  const [isRenaming, setIsRenaming] = useState(false);
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);
  const defaultTitle = I18n.text('academy-ai-assistant.drawer.defaultTitle');
  const displayTitle = row.title !== undefined && row.title !== '' ? row.title : defaultTitle;
  const handleRowClick = () => {
    if (isRenaming) return;
    trackEvent('conversation-opened');
    onOpen(row.conversationId);
  };
  const handleRenameClick = () => {
    setIsRenaming(true);
  };
  const handleDeleteClick = () => {
    setIsConfirmingDelete(true);
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const bucket = bucketFor(row.updatedAt);
  const formattedDate = bucket === 'today' || bucket === 'yesterday' ? `${I18n.text(`academy-ai-assistant.drawer.group.${bucket}`)} at ${I18n.moment.portalTz(row.updatedAt).format('LT')}` : I18n.moment.portalTz(row.updatedAt).format('ll');
  return /*#__PURE__*/_jsxs(View, {
    role: "option",
    "aria-selected": isActive,
    "data-test-id": `conversation-row-${row.conversationId}`,
    "data-menu-visible": isMenuOpen || undefined,
    onClick: handleRowClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    cursor: isRenaming ? 'default' : 'pointer',
    backgroundColor: isActive ? 'fill-surface-recessed' : isHovered ? 'fill-surface-default-hover' : undefined,
    borderRadius: "200",
    marginInlineStart: "400",
    paddingBlock: "100",
    paddingInline: "300",
    children: [isRenaming ? /*#__PURE__*/_jsx(RenameInput, {
      initialValue: (_row$title = row.title) !== null && _row$title !== void 0 ? _row$title : defaultTitle,
      ariaLabel: I18n.text('academy-ai-assistant.drawer.row.rename'),
      onSave: value => {
        setIsRenaming(false);
        trackEvent('conversation-renamed');
        onRename(row, value).catch(Raven.captureException.bind(Raven));
      },
      onCancel: () => setIsRenaming(false)
    }) : /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      gap: "200",
      children: [/*#__PURE__*/_jsx(View, {
        flex: 1,
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          truncate: true,
          children: displayTitle
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [(isMobile || isHovered || isMenuOpen) && /*#__PURE__*/_jsx(Text, {
          typography: "detail-100",
          color: "text-core-subtle",
          whiteSpace: "nowrap",
          children: formattedDate
        }), /*#__PURE__*/_jsx(View, {
          onClick: e => e.stopPropagation(),
          visibility: isMobile || isHovered || isMenuOpen ? 'visible' : 'hidden',
          children: /*#__PURE__*/_jsx(ActionsMenu, {
            referenceIndicator: /*#__PURE__*/_jsx(VerticalMenuIcon, {
              size: "100"
            }),
            shape: "circle",
            use: "transparent",
            referenceSize: "compact",
            menuInlineSize: 160,
            onOpenChange: value => setIsMenuOpen(value),
            actions: [{
              text: I18n.text('academy-ai-assistant.drawer.row.rename'),
              value: 'rename',
              indicator: /*#__PURE__*/_jsx(EditIcon, {
                size: "100"
              }),
              divider: true
            }, {
              text: I18n.text('academy-ai-assistant.drawer.row.delete'),
              value: 'delete',
              indicator: /*#__PURE__*/_jsx(DeleteIcon, {
                size: "100"
              })
            }],
            onActionClick: ({
              value
            }) => {
              if (value === 'rename') handleRenameClick();
              if (value === 'delete') handleDeleteClick();
            }
          })
        })]
      })]
    }), isConfirmingDelete ? /*#__PURE__*/_jsx(ConfirmModal, {
      message: I18n.text('academy-ai-assistant.drawer.row.deleteConfirmTitle'),
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "academy-ai-assistant.drawer.row.deleteConfirmMessage",
        options: {
          conversationName: /*#__PURE__*/_jsx("strong", {
            children: displayTitle
          })
        }
      }),
      confirmLabel: I18n.text('academy-ai-assistant.drawer.row.deleteConfirmLabel'),
      rejectLabel: I18n.text('academy-ai-assistant.drawer.row.deleteCancel'),
      onConfirm: () => {
        setIsConfirmingDelete(false);
        trackEvent('conversation-deleted');
        onDelete(row);
      },
      onReject: () => setIsConfirmingDelete(false)
    }) : null]
  });
};